import { defineComponent, onMounted, reactive } from '@vue/composition-api';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-get-file/dist/filepond-plugin-get-file.min.css';
import { useTitle } from '@/shared/hooks/useTitle';
import { endPoints } from '@/shared/types/api';
import { axios } from '@/plugins/axios';
import { download as downloadFile } from '@/utils/fileDownload';
import { Typography } from '@/components/parts';
import { useDialog } from '@/hooks/useDialog';
import { handleError } from '@/utils/handleError';

export default defineComponent({
  components: { Typography },
  setup() {
    const { setTitle } = useTitle();
    const state = reactive<{
      isLoading: boolean;
      errorMessage: string;
    }>({ isLoading: true, errorMessage: '' });
    const { state: dialogState, closeDialog, openDialog } = useDialog();

    onMounted(() => {
      setTitle({
        title: '受検者への周知文書',
        icon: 'mdi-square-edit-outline',
      });
    });

    const download = () => {
      openDialog();
      state.isLoading = true;

      return axios
        .get(endPoints.downloadOfficialDocument.endPoint, {
          responseType: 'blob',
        })
        .then(downloadFile)
        .catch((error) => {
          state.errorMessage = handleError(error);
        })
        .finally(() => {
          state.isLoading = false;
        });
    };

    return { download, state, dialogState, closeDialog };
  },
});
